import { DEVTOOLS_LOCAL_STORAGE_KEY } from './sharedConstants';
export const maybeCreateDevtools = (...args) => {
  try {
    if (localStorage.getItem(DEVTOOLS_LOCAL_STORAGE_KEY)) {
      void import('./devtools').then(mod => mod.createEntityDevtools(...args));
    }
  } catch (error) {
    console.error('Error initializing devtools', error);
  }
};